import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { FormlyModule } from '@ngx-formly/core';
import { FormlySelectModule } from '@ngx-formly/core/select';

import { TaFormlyFieldWrapperModule } from '../ta-field-wrapper/ta-field-wrapper.module';
import { TaRadioComponent } from './ta-radio.type';

@NgModule({
    declarations: [TaRadioComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        IonicModule,

        TaFormlyFieldWrapperModule,
        FormlySelectModule,
        FormlyModule.forChild({
            types: [
                {
                    name: 'ta-radio',
                    component: TaRadioComponent,
                    wrappers: ['ta-field-wrapper']
                }
            ]
        })
    ]
})
export class TaFormlyRadioModule { }
